import { withDefaultCurrency } from 'common/utils/formatUtils';
import { LoanProductFragment, LoanProductInput, ProductStatus } from 'generated/graphql';

export type MapLoanProductToInput = (product?: LoanProductFragment) => LoanProductInput;

export const mapLoanProductToInput: MapLoanProductToInput = (
  product = {
    creationTimestamp: new Date(),
    documents: [],
    enableFinancialAdvisorCare: true,
    enableNotifications: true,
    id: '',
    status: ProductStatus.Active,
    statusChangeDate: new Date(),
  },
) => {
  return {
    amount: withDefaultCurrency(product.amount),
    annualPercentageRate: product.annualPercentageRate,
    balance: withDefaultCurrency(product.balance),
    contractEndDate: product.contractEndDate,
    contractNumber: product.contractNumber,
    contractSignDate: product.contractSignDate,
    enableFinancialAdvisorCare: product.enableFinancialAdvisorCare,
    enableNotifications: product.enableNotifications,
    financialDetailsUpdatedAt: new Date(),
    institutionId: product.institution?.id,
    institutionName: product.institutionName,
    interestRate: product.interestRate,
    name: product.name,
    note: product.note,
    paymentInfo: {
      constantSymbol: product.paymentInfo?.constantSymbol,
      ibanForPayment: product.paymentInfo?.ibanForPayment,
      specificSymbol: product.paymentInfo?.specificSymbol,
      variableSymbol: product.paymentInfo?.variableSymbol,
    },
    paymentPeriod: {
      expectedAmount: withDefaultCurrency(product.paymentPeriod?.expectedAmount),
      periodCount: product.paymentPeriod?.periodCount,
      periodTypeCode: product.paymentPeriod?.periodTypeCode,
      referenceDate: product.paymentPeriod?.expectedDate,
    },
    status: product.status,
    statusChangeDate: product.statusChangeDate,
  };
};
